import { useFeatureValue as gbUseFeatureValue } from '@growthbook/growthbook-react';
import type { FeatureMap } from './helpers';

type FeatureValue<K extends keyof ExcludeKeysOfType<FeatureMap, boolean>> = ExcludeKeysOfType<FeatureMap, boolean>[K];

export const useFeatureValue = <
  K extends keyof ExcludeKeysOfType<FeatureMap, boolean>,
  V extends FeatureValue<K> | null = null,
>(
  flag: K,
  defaultValue?: V,
): { value: V extends null ? MaybeNull<FeatureValue<K>> : FeatureValue<K> } => {
  const value = gbUseFeatureValue(flag, defaultValue ?? null);

  return { value: value as V extends null ? MaybeNull<FeatureValue<K>> : FeatureValue<K> };
};
